import React from 'react';
import DesignPageContainer from './design.styles';
const DesignPage = () => {
    return (
        <DesignPageContainer>
            <div className="image">
                <img src="https://i.ibb.co/PF0vGns/mobile.png" alt="Mobile" />
            </div>
            <div className="text">
                <h2>Our Design Comes With...</h2>
                <ul>
                    <li>Responsive Design</li>
                    <li>Modern And Clean Design</li>
                    <li>Clean Code</li>
                    <li>Browser Friendly</li>
                </ul>
            </div>
        </DesignPageContainer>
    );
};

export default DesignPage;
